/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavGeoCode
 */
export interface InputUavGeoCode {
    /**
     * 
     * @type {string}
     * @memberof InputUavGeoCode
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavGeoCode
     */
    comment?: string;
    /**
     * Label — підпис для точки з мапи (для аліаса на НП ігнорується: підпис дає газетир).
     * @type {string}
     * @memberof InputUavGeoCode
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof InputUavGeoCode
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof InputUavGeoCode
     */
    lon?: number;
    /**
     * 
     * @type {number}
     * @memberof InputUavGeoCode
     */
    placeId?: number;
    /**
     * ScopeID — довідниковий підрозділ/екіпаж. Порожній допустимий лише разом із UnitName:
     * довідник uav_units наповнює ЛИШЕ парсер, тож підрозділу, який ще не подавав заявок,
     * у системі просто немає — а карту йому треба завести ДО першої заявки.
     * @type {number}
     * @memberof InputUavGeoCode
     */
    scopeId?: number;
    /**
     * 
     * @type {string}
     * @memberof InputUavGeoCode
     */
    scopeType: InputUavGeoCodeScopeTypeEnum;
    /**
     * UnitName — назва підрозділу вільним вводом (коли його ще нема в довіднику). Резолвиться
     * тим самим ResolveOrCreateUnit, що й підрозділ із заявки, тож заявка згодом злінкується
     * саме з цим записом, а не створить дубль.
     * @type {string}
     * @memberof InputUavGeoCode
     */
    unitName?: string;
}


/**
 * @export
 */
export const InputUavGeoCodeScopeTypeEnum = {
    Unit: 'unit',
    Crew: 'crew'
} as const;
export type InputUavGeoCodeScopeTypeEnum = typeof InputUavGeoCodeScopeTypeEnum[keyof typeof InputUavGeoCodeScopeTypeEnum];


/**
 * Check if a given object implements the InputUavGeoCode interface.
 */
export function instanceOfInputUavGeoCode(value: object): boolean {
    if (!('code' in value)) return false;
    if (!('scopeType' in value)) return false;
    return true;
}

export function InputUavGeoCodeFromJSON(json: any): InputUavGeoCode {
    return InputUavGeoCodeFromJSONTyped(json, false);
}

export function InputUavGeoCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavGeoCode {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'label': json['label'] == null ? undefined : json['label'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
        'placeId': json['placeId'] == null ? undefined : json['placeId'],
        'scopeId': json['scopeId'] == null ? undefined : json['scopeId'],
        'scopeType': json['scopeType'],
        'unitName': json['unitName'] == null ? undefined : json['unitName'],
    };
}

export function InputUavGeoCodeToJSON(value?: InputUavGeoCode | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'comment': value['comment'],
        'label': value['label'],
        'lat': value['lat'],
        'lon': value['lon'],
        'placeId': value['placeId'],
        'scopeId': value['scopeId'],
        'scopeType': value['scopeType'],
        'unitName': value['unitName'],
    };
}

